<template>
    <select
        :id="id"
        v-model="inputValue"
        class="Dropdown Dropdown--with-arrow"
        :class="extraClass"
        :name="id"
        :disabled="disabled"
        @change="onChange"
    >
        <option v-if="placeholder !== null" :value="-1">
            {{ placeholder }}
        </option>
        <option
            v-for="(option, index) in options"
            :key="buildKey(option, index)"
            :class="{ selected: index === inputValue }"
            :value="index"
        >
            {{ buildLabel(option) }}
        </option>
    </select>
</template>

<script lang="ts">
    import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

    // PRODUCT-26110 Task 12 (COMPONENT_V_MODEL): migrated to the Vue 3 v-model
    // contract (modelValue/update:modelValue). Consumed via v-model repo-wide
    // (AddressInput, BarLicenseDetails, BooleanComponent, Cpr, SelectOption, UsState,
    // ChargeDetails) and via manual :value/@input by JsonSchemaEnumForm.
    @Component({
        emits: [ 'update:modelValue' ] })
    export default class Dropdown extends Vue {
        @Prop({ type: Boolean, default: false })
        private disabled!: boolean;

        @Prop({ type: String, default: undefined })
        private extraClass!: string | undefined;

        @Prop({ type: String, default: undefined })
        private id!: string | undefined;

        @Prop({ default: 'Select one' })
        private placeholder!: string | null;

        @Prop({ default: null })
        private modelValue!: any;

        @Prop({ type: Array, default: () => [] })
        private options!: any[];

        @Prop({ type: Function, default: (value: any) => value })
        private buildLabel!: (value: any) => string;

        @Prop({ type: Function, default: (_: any, index: number) => index })
        private buildKey!: (value: any, index: number) => any;

        private inputValue = -1;

        @Watch('modelValue', { immediate: true })
        @Watch('options')
        private changeValue(value: any) {
            this.inputValue = this.options.indexOf(value);
        }

        private onChange() {
            const value = this.options[this.inputValue];

            if (this.modelValue !== value) {
                this.$emit('update:modelValue', value);
            }
        }
    }
</script>
